<template>
  <v-container>Default Docs </v-container>
</template>

<script>
export default {
  name: "DocsDefault",

  data: () => ({}),
};
</script>
